<script type="text/javascript">
	import simplebar from 'simplebar-vue';
	export default {
		components: { simplebar },
		props: {
					reply_route: {
						type: String,
						default: () => '/api/company/communication/support-thread/send-reply'
					},
					userview: {
						type: String,
						default: () => 'company'
					},
				user: {
				type: Object
					},
			  resource: {
		        type: String,
		        default: () => '',
		      },
		      resource_id: {
		        type: Number,
		        default: () => '',
		      },
		      api_token: {
		        type: String,
		        default: () => '',
		      },
		      resource_route: {
		        type: String,
		        default: () => '',
		      },
		      view: {
		        type: String,
		        default: () => 'list',
		      },
		      thread_list: {
		        type: Array,
		      },
		      thread_uid: {
		      		type: String,
		      		default: () => '',
		      },
		      expanded:{
		      	type: Number,
		      	default: () => 0
		      }
		  },
		  data(){
			return{
						loadingMessages: false,
		        quickviewproduct: '',
		        cthread_uid: 0,
		        active_thread: '',
		        data: {
		        	support_order_id: '',
							support_contact: '',
							status: 'seller-response',
		        	support_type: '',
							support_order: '',
							support_contact: '',
							name: '',
							email: '',
							telephone: '',
							mobile: '',
							subject: '',
							message: '',
							parent_id: '',
							customer_id: '',
		        },
		        support_types: [
					{
						text: 'Order Enquiry', value: 'order'
					},
					{
						text: 'Order Cancellation', value: 'cancellation'
					},
					{
						text: 'Delivery Issue', value: 'delivery'
					},
					{
						text: 'Product Enquiry', value: 'product'
					},
					{
						text: 'Technical Issue', value: 'tech'
					},
					{
						text: 'Account Issue', value: 'account'
					},
					{
						text: 'Pre-Sales Question', value: 'presales'
					}
				],
								}
		  },
		  mounted () {
			    window.addEventListener(
			         'popstate', this.handleHistoryChange
			         ) 
			},
		destroyed () {
		     window.removeEventListener(
		            'popstate', this.handleHistoryChange
		        ) 
		   },
		  methods: {
		  	sendReply(originalmessage){
		  		this.loadingMessages = true;
		  				var customer = '';
		  				if(this.userview == 'customer'){
		  					customer = this.getActiveThread.company;
		  				}else{
		  					customer = this.getActiveThread.customer;
		  				}
		  				this.data.support_type = originalmessage.support_type;
							this.data.support_order = originalmessage.support_order_id;
							this.data.support_order_id = originalmessage.support_order_id;
							this.data.support_contact = originalmessage.support_contact;
							this.data.name = originalmessage.name;
							this.data.email = originalmessage.email;
							this.data.telephone = originalmessage.telephone;
							this.data.subject = originalmessage.subject;
							this.data.customer_id = this.getActiveThread.customer.id;
							this.data.parent_id = this.getActiveThread.id;
							axios.post(this.reply_route, {data: this.data, customer: this.getActiveThread.customer, company: this.getActiveThread.company, type: this.getActiveThread.source} , {
								headers: {'Authorization' : 'Bearer '+this.user.api_token}
							}).then(response => {

								this.success_messagetext = "Your message has been sent";
								this.getActiveThread.thread_items.push(response.data);
								let self = this;
								setTimeout(function(){
									self.loadingMessages = false;
									self.success_message = true;
									var container = document.querySelector('#containerElement .simplebar-content-wrapper');
									var containerHeight = document.querySelector('#containerElement .simplebar-content-wrapper .simplebar-content');
									container.scrollTo({ top: (containerHeight.offsetHeight + 200), behavior: "smooth" });
								}, 500);
							}).catch(error => {
								this.error_reponse = error.response.error.errors;
							});
		  	},
		  	handleHistoryChange(){
		  		if(window.location.search == ''){
									this.active_thread = '';
								
								}
									this.cthread_uid = '';
		  	},
		  	uncollapseThread(thread){
		  		this.cthread_uid = thread.uid;
		  		this.loadList();
		  		if(thread.from == 'company'){
		  			this.$emit('mark-read', [thread.uid, true]);
		  		}
		  		var data = '{uid : ['+thread.thread_start+']}';
		  		if(this.userview == 'company'){
		  			history.pushState(data, '', "/communicate/customer-service/"+thread.uid);
		  		}else if(this.userview == 'customer'){
		  			history.pushState(data, '', "support?uid="+thread.uid);
		  		}
		  	},
		  	getSupportType(value){
		  		var support_item = this.support_types.filter(item => item.value = value);
		  		return support_item[0].text;
		  	},
		  	
		  	removeResource(){

		  	},
		  	priceIncVat(price, tax_percentage){
		      var tax = 1 + (tax_percentage / 100);
		      return price * tax;
		    },
		     loadList(){
		    	let self = this;
		    	setTimeout(function() {
		    		self.loadingMessages = false;
		    	}, 650);
		    },
		    getMessageFrom(index, thread){
		    	return thread[index]["from"];
		    }
		  },
		  created(){
		  	this.cthread_uid = this.thread_uid;
		  	this.loadingMessages = true;
		  	var url = window.location.href;
    		if(url.search("uid=") > 0){
              var cthread_uid = url.substring(url.lastIndexOf("=") + 1);
              console.log(cthread_uid);
              
        	}
        	
        	this.loadList();
		  },
		  computed: {
		  		getActiveThread(cthread_uid){
		  			
		  			//this.active_thread = this.thread_list.filter(item => item.uid == this.cthread_uid)[0];
		  				var list = this.thread_list.filter(item => item.uid == this.cthread_uid);
		  				if(list.length > 0){
								return list[0];
							}else{
								return '';
							}
		  		
		  	},
		  },
		  watch: {
		  	$route() {
			  		this.$nextTick(() => {
								if(window.location.search == ''){
									this.active_thread = '';
								}
						});
		  	}
		  }
	}
</script>

<template>
	<b-row>
		<b-col md="12" class="mt-4">
				<b-list-group class="list-group product-list w-100 no-shadow" v-if="(thread_list.length !== 0) && (view == 'list')">
                              <b-list-group-item v-for="(messagethread, key) in thread_list" class="list-group-item d-flex px-4 py-3 border product-list-item mb-2 w-100 border-radius-1em flex-column"  @click="uncollapseThread(messagethread)" href="javascript:;" v-if="getActiveThread == ''">
                              	<div class="d-flex">
                              	<div class="mr-3 avatar-sm" v-if="messagethread.customer.avatar == null">
                              		<span class="avatar-title rounded-circle">{{messagethread.customer.name.slice(0,1)}}</span>
                              	</div>
                              	<img v-else :src="storageurl + messagethread.customer.avatar" class="avatar-sm rounded-circle" >
                              	<div class="d-flex w-25">
                              	
                              	<div class="d-flex flex-column my-auto">
                              		{{messagethread.customer.name}} {{messagethread.customer.lastname}}
                              		<a href="">{{messagethread.customer.email}}</a>
                              	</div>
                              </div>
                              <div class="my-auto ml-4 flex-grow-1 d-flex">
                              	<div class="d-flex flex-column">
                                	<p class="my-auto mr-2">#{{messagethread.uid}}</p>
                                	<p class="my-auto">
                                	{{getSupportType(messagethread.support_type)}}:
						            					{{messagethread.subject}}
						            					</p>
						            				</div>
						            						<span class="ml-auto" v-if="messagethread.thread_items.length !== 0">Last Message From: <span class="badge badge-light bg-light">{{getMessageFrom(messagethread.thread_items.length - 1, messagethread.thread_items)}}</span></span>
						            		<span class="ml-auto" v-else>Last Message From: <span class="badge badge-light bg-light">{{messagethread.from}}</span></span>
                                </div>
                              </div>
                              	
                                 	<div class="d-flex product-list-item-container w-100 border-top mt-3 pt-2">
                              	
																	<div class="mr-3 avatar-sm">
																	</div>

                                <span class="text-muted italic no-margin my-auto mr-auto"  v-b-tooltip.hover title="Conversation Started"><i class="bx bx-calendar text-primary font-size-14"></i> {{messagethread.created_at | luxon({input: 'server', output: 'time'})}}</span>
                                <span v-b-tooltip.hover title="Last Message Received" class="text-muted italic no-margin my-auto mr-auto"><i class="bx bx-calendar text-primary font-size-14"></i> {{messagethread.updated_at | luxon({input: 'server', output: 'time'})}}</span>
                                <span v-if="messagethread.read_at !== null">{{messagethread.read_at | luxon({input: 'sql', output: 'time'}) }}</span>
						            		<span v-else class="my-auto badge badge-danger bg-danger">Message Unread</span>
						            <span class="text-muted ml-auto my-auto" v-if="messagethread.thread_items.length > 0">
						            		<div v-if="getMessageFrom(messagethread.thread_items.length - 1, messagethread.thread_items) == userview">
						            			<span class="badge badge-primary bg-primary text-white">Awaiting Reply</span>
						            		</div>
						            		<div v-if="getMessageFrom(messagethread.thread_items.length - 1, messagethread.thread_items) !== userview">
						            			<span class="badge badge-danger bg-danger text-white">Response Required</span>
						            		</div>

						            </span>
						            <span class="text-muted ml-auto my-auto" v-else>
						            	<div>
						            			<span v-if="messagethread.from == userview" class="badge badge-primary bg-primary text-white">Awaiting Reply</span>
						            			<span v-if="messagethread.from !== userview" class="badge badge-danger bg-danger text-white">Response Required</span>
						            		</div>
						            </span>
						            <strong class="text-muted my-auto"></strong>
                                <div class=" ml-3 my-auto d-flex">
                                	<a class="btn btn-outline-light btn-rounded rounded-circle ml-auto my-auto flex-grow-3" @click="uncollapseThread(messagethread)" href="javascript:;"><i class="mdi mdi-eye-outline"></i></a>
                                <!--<a class="btn btn-outline-light btn-rounded ml-auto my-auto" href="javascript:;" @click="removeResource(product)"><i class="py-1 px-2 bx bx-trash-alt"></i></a>-->
                            	</div>
                              </div>
                              </b-list-group-item>
                          <b-list-group-item v-if="getActiveThread !== ''">
                          	<b-overlay :show="loadingMessages">
                          	<b-card class="border-radius-1em border shadow-none" body-class="p-0">	
                          		<b-row class="p-3">
                          			<b-col md="8">
                          		<!--<span class="text-capitalize">From: {{getActiveThread.customer.name}} {{getActiveThread.customer.lastname}}</span>-->
                          		<span class="text-muted italic no-margin my-auto ml-auto mr-auto"><i class="bx bx-calendar text-primary font-size-14"></i> {{getActiveThread.created_at | luxon({input: 'server'})}}</span>
                          		<span>
                          			{{getSupportType(getActiveThread.support_type)}}
                          		</span>
                          		<h4 class="m-0">
                          			{{getActiveThread.subject}}
                          		</h4>

                          		<!--<div class="messages-content bg-light border-radius-1em p-3 mb-3" :class="{'text-right' : message.from == 'company'}" v-for="message in getActiveThread">
                          			<h6 class="text-capitalize">From: {{message.from}}</h6>
                          			{{message.notification.data.message}}
                          		</div>-->
                          	</b-col>
                          	<b-col md="4">
                          	</b-col>
                          </b-row>
                          		<div class="chat-conversation p-3">
									              <simplebar
									                style="max-height: 470px"
									                id="containerElement"
									                ref="current"
									              >
									                <ul class="list-unstyled">
									                  <li>
									                    <div class="chat-day-title">
									                      <span class="title">Conversation Started: {{getActiveThread.created_at | luxon({input: 'server'})}}</span>
									                    </div>
									                  </li>
									                  <li  :class="{'right' : getActiveThread.from == 'customer' && userview == 'customer'}" >
									                    <div class="conversation-list">
									                     <!--<b-dropdown
									                        variant="white"
									                        menu-class="dropdown-menu-end"
									                      >
									                        <template v-slot:button-content>
									                          <i class="bx bx-dots-vertical-rounded"></i>
									                        </template>
									                        <b-dropdown-item>Copy</b-dropdown-item>
									                        <b-dropdown-item>Save</b-dropdown-item>
									                        <b-dropdown-item>Forward</b-dropdown-item>
									                        <b-dropdown-item>Delete</b-dropdown-item>
									                      </b-dropdown>-->
									                      <div class="ctext-wrap">
									                        <div class="conversation-name">
									                        	<span v-if="getActiveThread.from == 'company'">
									                        		<span v-if="userview == 'company'">
									                        			You
									                        		</span>
									                        		<span v-if="userview == 'customer'">
									                        		Company
									                        		</span>
									                        	</span>
									                        	<span v-if="getActiveThread.from == 'customer'">
									                        		<span v-if="userview == 'company'">
									                        			Customer
									                        		</span>
									                        		<span v-if="userview == 'customer'">
									                        			You
									                        		</span>
									                        	</span>
									                        </div>
									                        <p>{{getActiveThread.message}}</p>
									                        <p class="chat-time mb-0">
									                          <i class="bx bx-time-five align-middle me-1"></i>
									                          {{getActiveThread.created_at | luxon({input: 'server', output: 'time'})}}
									                        </p>
									                      </div>
									                    </div>
									                  </li>
									                  <li v-for="message in getActiveThread.thread_items" :class="{'right' : message.from == userview}" >
									                    <div class="conversation-list">
									                     <!--<b-dropdown
									                        variant="white"
									                        menu-class="dropdown-menu-end"
									                      >
									                        <template v-slot:button-content>
									                          <i class="bx bx-dots-vertical-rounded"></i>
									                        </template>
									                        <b-dropdown-item>Copy</b-dropdown-item>
									                        <b-dropdown-item>Save</b-dropdown-item>
									                        <b-dropdown-item>Forward</b-dropdown-item>
									                        <b-dropdown-item>Delete</b-dropdown-item>
									                      </b-dropdown>-->
									                      <div class="ctext-wrap">
									                        <div class="conversation-name">
									                        	<span v-if="message.from == 'company'">
									                        		<span v-if="userview == 'company'">
									                        			You
									                        		</span>
									                        		<span v-if="userview == 'customer'">
									                        		Company
									                        		</span>
									                        	</span>
									                        	<span v-if="message.from == 'customer'">
									                        		<span v-if="userview == 'company'">
									                        			Customer
									                        		</span>
									                        		<span v-if="userview == 'customer'">
									                        			You
									                        		</span>
									                        	</span>
									                        </div>
									                        <p>{{message.message}}</p>
									                        <p class="chat-time mb-0">
									                          <i class="bx bx-time-five align-middle me-1"></i>
									                          {{message.created_at | luxon({input: 'server', output: 'time'})}}
									                        </p>
									                      </div>
									                    </div>
									                  </li>
									                </ul>
									              </simplebar>
									            </div>
									            <div class="p-3 chat-input-section">
									            	  <b-row>
									            	  	<transition name="fade-top">
											              	<b-col v-if="success_message == true">
											              		<b-alert variant="success" dismissible @dismissed="success_message = !success_message" :show="true">{{success_messagetext}}</b-alert>
											              	</b-col>
									              	</transition>
									              </b-row>
              <div class="row">
                <div class="col">
                  <div class="position-relative">
                    <!--<input
                      type="text"
                      class="form-control chat-input"
                      placeholder="Enter Message..."
                    />-->
                    <textarea
                      type="text"
                      class="form-control chat-input"
                      placeholder="Enter Message..."
                      v-model="data.message"
                    ></textarea>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                            href="#"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Emoji"
                            ><i class="mdi mdi-emoticon-happy-outline"></i
                          ></a>
                        </li>
                        <li class="list-inline-item">
                          <a
                            href="#"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Images"
                            ><i class="mdi mdi-file-image-outline"></i
                          ></a>
                        </li>
                        <li class="list-inline-item">
                          <a
                            href="#"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Add Files"
                            ><i class="mdi mdi-file-document-outline"></i
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button v-if="getActiveThread.status !== 'closed'"
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md waves-effect waves-light"
                    @click="sendReply(getActiveThread)"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </div>
            </div>
                          	</b-card>
                          		</b-overlay>
                          </b-list-group-item>

                              <!--<li class="list-group-item py-4 text-center" ><a class="btn btn-outline-light btn-rounded">Load More</a>
                              </li>-->
           </b-list-group>
               
		</b-col>
	</b-row>
</template>